import styled from 'styled-components';
import { SecondaryButton } from 'ui/button';
import { RightTooltip } from 'ui/tooltip/Tooltip';
import { Add16 } from 'ui/icons/action/Add16';
import { useTranslation } from '../hooks/useTranslation';
import { useHasMaximumClauses, useAddClause } from '../hooks/form';

const AddButton = styled(SecondaryButton)`
  width: fit-content;
`;

const StyledRightTooltip = styled(RightTooltip)`
  width: fit-content;
`;

export const AddVariantButton = () => {
  const hasMaxClauses = useHasMaximumClauses();
  const onAdd = useAddClause();
  const { t } = useTranslation();

  return (
    <StyledRightTooltip tooltipContent={t('addVariant.tooltip')} isEnabled={hasMaxClauses}>
      <AddButton onClick={onAdd} isDisabled={hasMaxClauses}>
        <Add16 />
        {t('addVariant.button')}
      </AddButton>
    </StyledRightTooltip>
  );
};
